unit PrepareOperationDisposableItemType;
{

/* Property TypeName added. */

/* Initial. */

}
interface

type
  TPrepareOperationDisposableItemType = class
  private
    fPrepareOperationDisposableKey: String;
    fPrepareOperationName: String;
    fTypeName: String;
    fDisposableName: String;
    fAmountInPrepareOperation: Byte;
  public
    property PrepareOperationDisposableKey: String read fPrepareOperationDisposableKey;
    property PrepareOperationName: String read fPrepareOperationName;
    property TypeName: String read fTypeName;
    property DisposableName: String read fDisposableName;
    property AmountInPrepareOperation: Byte read fAmountInPrepareOperation;
  end;

implementation

end.
